import React from "react";
import { Input, type StrictInputProps } from "semantic-ui-react";

type SemanticProps = Omit<StrictInputProps, "value" | "initialValue" | "onChange" | "onBlur" | "error">;

export interface InputBaseProps extends SemanticProps {
  error: string | boolean
  onChange: (newName: string) => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent) => void
  value: string
  maxLength: number
  placeholder?: string
  innerRef?: React.MutableRefObject<Input>
  hideLabel?: boolean
}

const InputBaseWithErrorLabel = (props: InputBaseProps) => {
  const { error, onChange: propsOnChange, value, innerRef, ...rest } = props;

  const onChange = (_, { value }) => propsOnChange(value);

  return <div>
    <Input
      {...rest}
      ref={innerRef}
      error={Boolean(error)}
      value={value}
      onChange={onChange}
      onBlur={props.onBlur}
      onKeyDown={props.onKeyDown}
    />
    {(typeof error === "string" && !props.hideLabel) && <div className="s1_red">{error}</div>}
  </div>
};

export default InputBaseWithErrorLabel;